import { ref } from 'vue'
import Api from "../Api"
import Image from "@/services/Image"

export function useWishlists() {
    const formattedWishlists = ref([])
    const isLoading = ref(false)

    const formatElement = (item) => {
        let value = item["wishlist_id"] ?? 0
        let name = item["wishlist_name"] ?? ""
        let hasImage = item["wishlist_image_host"] && item["wishlist_image_name"]

        if (value === 0 || name === "") {
            return []
        }

        return [{
            value,
            name,
            image: hasImage ? Image.handle(item["wishlist_image_host"], item["wishlist_image_name"], 60, 60) : null
        }]
    }

    const fetchWishlists = async () => {
        isLoading.value = true

        try {
            const items = await Api.wishlists()
            formattedWishlists.value = Object.values(items).flatMap(formatElement)
        } catch (error) {
            console.error("Не удалось загрузить список вишлистов:", error)
        } finally {
            isLoading.value = false
        }
    }

    return {
        formattedWishlists,
        isLoading,
        fetchWishlists
    }
}
